export const ADMIN_STATUS_TRANSITIONS: Record<string, string[]> = {
  submitted: ['pending_yellow', 'pending_red', 'approved', 'rejected', 'deleted'],
  pending: ['approved', 'rejected', 'deleted'],
  pending_yellow: ['approved', 'rejected', 'deleted'],
  pending_red: ['pending_yellow', 'rejected', 'deleted'],
  pre_approved: ['pending_yellow', 'pending_red', 'approved', 'rejected', 'deleted'],
  approved: ['paid'],
  pending_payment: [],
  paid: [],
  rejected: ['deleted'],
  deleted: [],
};

/** Bulk targets, keyed by target status -> source statuses allowed to move into it.
 *  Kept in step with `BULK_STATUS_TRANSITIONS` in
 *  packages/backend/src/services/claims/bulk-approve.js by test assertion, not import. */
export const BULK_STATUS_TRANSITIONS: Record<string, string[]> = {
  approved: ['submitted', 'pending_yellow', 'pre_approved'],
  paid: ['approved'],
};

export const ADMIN_STATUS_OPTIONS = [
  { value: 'submitted', label: 'Submitted' },
  { value: 'pending_yellow', label: 'Pending' },
  { value: 'pending_red', label: 'Pending' },
  { value: 'pre_approved', label: 'Pre-Approved' },
  { value: 'approved', label: 'Approved' },
  { value: 'pending_payment', label: 'Pending Payment' },
  { value: 'paid', label: 'Paid' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'deleted', label: 'Deleted' },
];

export function getEffectiveStatusKey(status: string, flag?: 'yellow' | 'red' | null): string {
  return status === 'pending' && flag ? `pending_${flag}` : status;
}

export function resolveStatusOption(key: string): {
  status: string;
  flag: 'yellow' | 'red' | null;
} {
  if (key === 'pending_yellow') return { status: 'pending', flag: 'yellow' };
  if (key === 'pending_red') return { status: 'pending', flag: 'red' };
  return { status: key, flag: null };
}
